/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Order status enumeration (canonical platform definition).  This is the single canonical platform `OrderStatus`, relocated from the root crate\'s `types::unified` as the first GAP-BUILD-009 canonicalization increment. The root crate re-exports it (NAMED) from `crate::types::unified`, so every `crate::types::unified::OrderStatus` call site resolves unchanged.  It uses a custom case-insensitive deserializer, allowing the API to accept `\"open\"`, `\"Open\"`, `\"OPEN\"`, `\"partially_filled\"`, etc.  NOTE: this is distinct from the venue-layer `crate::venue::OrderStatus` (which models an exchange `Acknowledged` ack) and from the backtest crate\'s internal execution/matching state machines. Those are deliberately separate concepts and are NOT unified by this type.
 */
export enum OrderStatus {

    New = 'New',

    Pending = 'Pending',

    Submitted = 'Submitted',

    Accepted = 'Accepted',

    Open = 'Open',

    PartiallyFilled = 'PartiallyFilled',

    Filled = 'Filled',

    Completed = 'Completed',

    Cancelled = 'Cancelled',

    Canceled = 'Canceled',

    Rejected = 'Rejected',

    Expired = 'Expired',

    Unknown = 'Unknown'
}
